import { connect } from 'react-redux';
import KTP from '../../components/ktp/KTP';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(KTP);
